// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data: image/svg+xml,%3Csvg width=%2710%27 height=%279%27 viewBox=%270 0 10 9%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 5L3.5 7.5L9 1%27 stroke=%27white%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 /%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-root input[type='radio'].hb-radio,
app-root input[type='checkbox'].hb-checkbox {
  -webkit-appearance: none;
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--background-grey);
  margin: 0;
  position: relative;
  top: 50%;
  width: 1em;
  height: 1em;
  font: inherit;
  color: currentColor;
  border: 0.0625em solid currentColor;
  border-radius: 50%;
  transition: box-shadow 0.2s ease-out, border-color 0.2s ease-out;
}
app-root input[type='radio'].hb-radio::before,
app-root input[type='checkbox'].hb-checkbox::before {
  will-change: transform;
  position: relative;
  display: block;
  z-index: 3;
  border-radius: 50%;
  transform: scale(0);
  transition: transform 0.15s ease-in-out;
  box-shadow: inset 1em 1em var(--selection-grey);
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}
app-root input[type='radio'].hb-radio + label,
app-root input[type='checkbox'].hb-checkbox + label {
  padding-left: 0.4em;
}
app-root input[type='radio'].hb-radio:hover,
app-root input[type='checkbox'].hb-checkbox:hover {
  border-color: var(--hover-grey);
  box-shadow: 0 0 0 2px var(--outline-hover-grey);
}
app-root input[type='checkbox'].hb-checkbox::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: white;
  width: 1em;
  height: 1em;
  line-height: 0.95em;
  text-align: center;
  top: -0.0625em;
  left: -0.0625em;
  transform: scale(0) rotate(-30deg);
  transition-duration: 0.1s;
}
app-root input[type='checkbox'].hb-checkbox:checked::before {
  transform: scale(1);
}
app-root input[type='radio'].hb-radio::before {
  content: '';
  width: 0.5em;
  height: 0.5em;
  top: 0.1875em;
  left: 0.1875em;
}
app-root input[type='radio'].hb-radio:checked::before {
  transform: scale(1);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Form/Inputs/Generic/Multi/MultiInput.less","webpack://./src/Components/Form/Inputs/Generic/Multi/Utilities/baseStyle.less"],"names":[],"mappings":"AAEA;;ECAE,wBAAA;EACA,gBAAA;EDCA,iBAAiB;ECCjB,wCAAA;EACA,SAAA;EAEA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EDVE,gEAAA;AAUJ;ACEE;;EACE,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,+CAAA;EDCF,+BAA+B;ECE7B,4BAAA;ADAJ;AAtBI;;EACE,mBAAA;AAyBN;AAvBI;;EACE,+BAAA;EACA,+CAAA;AA0BN;ACJE;EACE,gDAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kCAAA;EACA,yBAAA;ADMJ;ACHE;EACE,mBAAA;ADKJ;ACAE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;ADEJ;ACCE;EACE,mBAAA;ADCJ","sourcesContent":["@import './Utilities/baseStyle.less';\n\napp-root {\n  input[type='radio'].hb-radio,\n  input[type='checkbox'].hb-checkbox {\n    .shared-multi-input-styles();\n    transition: box-shadow 0.2s ease-out, border-color 0.2s ease-out;\n    & + label {\n      padding-left: 0.4em;\n    }\n    &:hover {\n      border-color: var(--hover-grey);\n      box-shadow: 0 0 0 2px var(--outline-hover-grey);\n    }\n  }\n\n  input[type='checkbox'].hb-checkbox {\n    .checkbox-input-styles();\n  }\n\n  input[type='radio'].hb-radio {\n    .radio-input-styles();\n  }\n}\n",".shared-multi-input-styles() {\n  // Resets\n  -webkit-appearance: none;\n  appearance: none;\n  /* For iOS < 15 */\n  background-color: var(--background-grey);\n  margin: 0;\n\n  position: relative;\n  top: 50%;\n  width: 1em;\n  height: 1em;\n\n  font: inherit;\n  color: currentColor;\n  border: 0.0625em solid currentColor;\n  border-radius: 50%;\n\n  &::before {\n    will-change: transform;\n    position: relative;\n    display: block;\n    z-index: 3;\n    border-radius: 50%;\n    transform: scale(0);\n    transition: transform 0.15s ease-in-out;\n    box-shadow: inset 1em 1em var(--selection-grey);\n\n    /* Windows High Contrast Mode */\n    background-color: CanvasText;\n  }\n}\n\n.checkbox-input-styles() {\n  &::before {\n    content: url(\"data: image/svg+xml,%3Csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L3.5 7.5L9 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E\");\n    color: white;\n    width: 1em;\n    height: 1em;\n    line-height: 0.95em;\n    text-align: center;\n    top: -0.0625em;\n    left: -0.0625em;\n    transform: scale(0) rotate(-30deg);\n    transition-duration: 0.1s;\n  }\n\n  &:checked::before {\n    transform: scale(1);\n  }\n}\n\n.radio-input-styles() {\n  &::before {\n    content: '';\n    width: 0.5em;\n    height: 0.5em;\n    top: 0.1875em;\n    left: 0.1875em;\n  }\n\n  &:checked::before {\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
